export default "__VITE_ASSET__1c2b0b8a__"